export default __webpack_public_path__ + "static/Metal_Ceiling-5a031807931b78d8890184d8589996d2.png";